import React, { useEffect, useState } from "react";
import ProgressBar from "react-bootstrap/ProgressBar";

import {
  addTokenToWallet,
  calculateToken,
  callReadContract,
  callWriteContract,
  formatBalance,
  formatNumber,
  getTxn,
  getUserBalances,
  parsBalance,
} from "../../../Contract/utils";
import erc20 from "../../../Contract/erc20.json";
import zeussToken from "../../../Contract/zeussToken.json";
import icoContract from "../../../Contract/ISOContract.json";
import { toast } from "react-toastify";
import { useAccount, useConnect, useDisconnect, useWalletClient } from "wagmi";
import Stake from "../Staking/Modal/Stake";
import { Link } from "react-router-dom";
const Calculator = ({ update }) => {
  const { data: walletClient } = useWalletClient();

  const addToken = async () => await addTokenToWallet(walletClient);

  const options = [
    {
      label: "USDT",
      value: 0,
      decimal: 6,
      image: "/images/usdt-removebg-preview.png",
    },
    {
      label: "USDC",
      value: 1,
      decimal: 6,
      image: "/images/invest1.png",
    },
    {
      label: "FDUSD",
      value: 2,
      decimal: 18,
      image: "/images/invest4.png",
    },
    {
      label: "BUSD",
      value: 3,
      decimal: 18,
      image: "/images/invest2.png",
    },
  ];
  const user = useAccount();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [balance, setBalance] = useState("");
  const [amount, setAmount] = useState("1");
  const [tokenValue, setTokenValue] = useState("");
  const [tokenToGet, setTokenToGet] = useState("");
  const [soldTokens, setSoldTokens] = useState("");
  const [buyHistory, setBuyHistory] = useState();
  const [buyStake, setBuyStake] = useState(false);
  const [openStake, setOpenStake] = useState(false);
  const [trans, setTrans] = useState("");

  const getValue = async () => {
    try {
      const tokens = await calculateToken(parsBalance(amount, 6));

      setTokenToGet(formatBalance(tokens, 18, 2));
    } catch (e) {
      console.log("error in get value", e);
    }
  };
  const getCurrentValue = async () => {
    try {
      const tokenVal = await callReadContract(
        icoContract.address,
        icoContract.abi,
        "getCurrentPrice"
      );

      setTokenValue(formatBalance(tokenVal.toString(), 6, 6));
    } catch (e) {
      console.log("error in get value", e);
    }
  };
  const getUserBuyHistory = async () => {
    try {
      const buyHistory = await callReadContract(
        icoContract.address,
        icoContract.abi,
        "getUserTransactionHistory",
        [user.address]
      );
      setBuyHistory([...buyHistory].reverse());
    } catch (e) {
      console.log("error in get value", e);
    }
  };
  const getSoldtokens = async () => {
    try {
      const tokenSold = await callReadContract(
        icoContract.address,
        icoContract.abi,
        "tokenSold"
      );
      setSoldTokens(tokenSold.toString());
    } catch (e) {
      console.log("error in get value", e);
    }
  };

  const getBal = async () => {
    try {
      const bal = await getUserBalances(
        user.address,
        zeussToken.address,
        zeussToken.abi
      );

      setBalance(formatBalance(bal, 18, 2));
    } catch (e) {
      console.log("error in get bal", e);
    }
  };

  const buyToken = async () => {
    try {
      if (amount === "") {
        toast.error("No amount added!");
        return;
      }

      const bal = await getUserBalances(
        user.address,
        erc20[selectedOption.label],
        erc20.abi
      );

      if (amount > bal) {
        toast.error("Token balance is less than the required amount!");
        return;
      }

      let load = toast.loading("Buying...");

      const buyAmount = parsBalance(amount, selectedOption.decimal);

      // Approving transaction
      const approve = await callWriteContract(
        erc20.USDT,
        erc20.abi,
        "approve",
        [icoContract.address, buyAmount]
      );

      if (!approve) {
        toast.error("Approving Failed!");
        toast.dismiss(load);
        return;
      }

      const tx = await callWriteContract(
        icoContract.address,
        icoContract.abi,
        "buy",
        [buyAmount, selectedOption.value]
      );

      const receipt = await getTxn(tx);
      if (!receipt) {
        toast.error("Buying Failed!");
        toast.dismiss(load);
        return;
      }

      toast.success("Buying Successfull!");
      toast.dismiss(load);
      setTrans(tx);
      update(tx);
      if (buyStake) {
        setOpenStake(true);
      }
    } catch (e) {
      console.log("error in buy", e);
      toast.error("⚠️ Transaction Error!");
      toast.dismiss();
    }
  };
  useEffect(() => {
    if (amount) {
      getValue();
    } else {
      setTokenToGet("0");
    }
  }, [amount]);

  useEffect(() => {
    if (user.address) {
      getBal();
      getUserBuyHistory();
    }
    getCurrentValue();
    getSoldtokens();
  }, [user, trans]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handleOptionClick = (option) => {
    setAmount("");
    setSelectedOption(option);
    setIsOpen(false);
  };

  return (
    <>
      <div className="calculator">
        <Stake
          onStake={setTrans}
          bal={balance}
          tokenValue={tokenValue}
          setTxn={setTrans}
          show={openStake}
          btn={false}
          setOpenStake={setOpenStake}
          tokenToStake={tokenToGet}
        />
        <div className="content">
          <h2>$ZEUSS Pre-Sale</h2>
          <div className="progress">
            <span>
              {formatNumber(formatBalance(soldTokens, 18, 2))}/20B $ZEUSS
            </span>
            <ProgressBar
              now={formatBalance(soldTokens, 18, 2)}
              max={"20000000"}
            />
          </div>
          <div className="launch-price">
            <h4>
              Current PreSale Price = <span>${tokenValue}</span>
            </h4>
          </div>
          <form className="calculateform">
            <div className="form-group">
              <div className="form-heading">
                <label>I want to spend</label>
              </div>

              <div className="form">
                <div>
                  <input
                    maxLength={10}
                    type="text"
                    value={amount}
                    className="form-control"
                    placeholder="10 - 10000"
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </div>
                <div className="select">
                  <div className="dropdown">
                    <div className="dropdown-header" onClick={toggleDropdown}>
                      {selectedOption && (
                        <div className="dropdown-selected">
                          <img
                            src={selectedOption.image}
                            alt={selectedOption.label}
                          />
                          <span>{selectedOption.label}</span>
                          <i
                            className={`dropdown-icon ${isOpen ? "open" : ""}`}
                          >
                            <img src="/images/calculatedrop.png" alt="" />
                          </i>
                        </div>
                      )}
                    </div>
                    {isOpen && (
                      <div className="dropdown-list">
                        {options.map((option) => (
                          <div
                            key={option.label}
                            className="dropdown-item"
                            onClick={() => handleOptionClick(option)}
                          >
                            <img src={option.image} alt={option.label} />
                            <span>{option.label}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="form-heading">
                <label>I will receive</label>
                <label>{`${amount} ${selectedOption.label} = ${tokenToGet} ZEUSS `}</label>
              </div>
              <div className="form">
                <div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="0"
                    disabled
                    value={tokenToGet}
                  />
                </div>
                <div className="select">
                  <img src="/images/zeusscircle.png" alt="" />
                </div>
              </div>
            </div>
            <div className="calculate-btn">
              {/* <button
                type="button"
                disabled='true'
                className="btn form-control"
                onClick={async () => {
                  setBuyStake(true);
                  buyToken();
                }}
              >
                Buy & Stake $ZEUSS
              </button> */}
              {/* <a target="_blank" href="https://www.paypal.com/ncp/payment/96YPBGW4W8UCU">
              <button
                type="button"
                className="btn form-control"
                >
                Buy with PayPal & Credit Cards
              </button>
                </a> */}
              <button
                type="button"
                className="btn form-control"
                onClick={() => {
                  setBuyStake(false);
                  buyToken();
                }}
              >
                Buy $ZEUSS
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
export default Calculator;
